// import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';
import { thunk } from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storageImport from 'redux-persist/lib/storage';
// import devToolsEnhancer from 'remote-redux-devtools';
import rootReducer from './reducers';

/**
 * Vite + CJS interop can nest default exports twice (`mod.default.default`).
 * redux-persist's web storage must expose .getItem/.setItem or persist breaks at runtime.
 */
function resolveReduxPersistWebStorage(mod) {
  if (!mod) return mod;
  if (typeof mod.getItem === 'function') return mod;
  const a = mod.default;
  if (a && typeof a.getItem === 'function') return a;
  if (a && a.default && typeof a.default.getItem === 'function') return a.default;
  return mod;
}

const reduxPersistWebStorage = resolveReduxPersistWebStorage(storageImport);

const initialState = {};
const middleware = [thunk];

const createNoopStorage = () => {
  return {
    getItem(_key) {
      return Promise.resolve(null);
    },
    setItem(_key, value) {
      return Promise.resolve(value);
    },
    removeItem(_key) {
      return Promise.resolve();
    },
  };
};

// Check if we're in a browser environment with localStorage available
const isClient = typeof window !== 'undefined';
const hasLocalStorage = isClient && typeof window.localStorage !== 'undefined';

let storageToUse;
try {
  if (hasLocalStorage) {
    // Test if localStorage is actually usable
    const testKey = '__redux_persist_test__';
    window.localStorage.setItem(testKey, 'test');
    window.localStorage.removeItem(testKey);
    const candidate =
      reduxPersistWebStorage && typeof reduxPersistWebStorage.getItem === 'function'
        ? reduxPersistWebStorage
        : null;
    storageToUse = candidate || createNoopStorage();
  } else {
    storageToUse = createNoopStorage();
  }
} catch (e) {
  // If localStorage is not available or throws an error, use noop storage
  storageToUse = createNoopStorage();
}

const persistConfig = {
  key: 'root',
  storage: storageToUse,
  whitelist: ['intakeReducer', 'authReducer'],
  blacklist: ['programMatchReducer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({})
    : compose;

const enhancer = composeEnhancers(applyMiddleware(...middleware));

const store = createStore(persistedReducer, initialState, enhancer);

const persistor = persistStore(store);

export { store, persistor };